module.exports = {
  language: {
    name: 'CN',
    url: '/static/images/a1.png',

    tophtml: '<h1>"&nbsp;We provide <br />&nbsp; &nbsp;valuable platforms for <br />&nbsp; &nbsp;businesses and consumers &nbsp;"</h1><h3>&nbsp; &nbsp; &nbsp;—— &nbsp;Nanjing Stuttgart Joint Exhibition Ltd.</h3>',
    tophtml1: "We provide valuable platforms for businesses and consumers",
    tophtml2: "—— Nanjing Stuttgart Joint Exhibition Ltd.",
    placeholder: "select date",
    placeholder2: 'please select',
    lang: 'en',
    errmsg1: 'Getting information failure！',
    errmsg2: 'Network error!',
    formmsg1: 'Incomplete information, please improve the information!',
    partners: 'Partners',
    education: [
      {
        value: "1",
        label: "junior college",
      },
      {
        value: "2",
        label: "undergraduate",
      },
      {
        value: "3",
        label: "graduate student",
      },
      {
        value: 4,
        label: "doctor"
      }
    ],
    exhibitionname: 'Exhibtions',
    exhibitiontitle: "Exhibitions",
    exhibitonst1: [{
      id: 1,
      name: 'Education&Training'
    }, {
      id: 2,
      name: 'Innovation'
    }, {
      id: 3,
      name: 'Industrial Solutions'
    },
    {
      id: 4,
      name: 'Lifestyle&Leisure'
    }
    ],
    exhibitonst2: [
      {
        id: 4,
        name: 'Lifestyle&Leisure'
      },
      {
        id: 3,
        name: 'Industrial Solutions'
      },
      {
        id: 5,
        name: 'Business&Education'
      }
    ],
    demondtitle: "Exhibition demand",
    demond: [{
      id: 1,
      name: 'More information'
    },
    {
      id: 2,
      name: 'Register as a visitor'
    },
    {
      id: 3,
      name: 'Invitation letter for business purpose'
    },
    {
      id: 4,
      name: 'Exhibition tickets &invitation letter'
    }
    ],
    exhibitionhome: 'Please fill in the form and send the above information to the company email in word format: marketing@messenanjing.cn',
    exhibitionglob: 'Please fill in the form and send the above information to the company email in word format: gina.ji @ messenanjing.cn',
    revsertitle: 'Welcome To Nanjing International Expo Center',
    revserbtn: 'Venue Reservation',
    mediatitle: "Media Center",
    mediavideo: "Video Highlights",
    medianews: "Company News",
    moretext: "learn more",
    jointext: 'JOIN US',
    joinbtntext: 'Join us',
    btcontact: 'Contact us',
    jontitle: "Recruitments",
    pagetextup: 'Page up:',
    pagetextdown: 'Page down:',
    joinus1: 'Online job search',
    joinus2: 'If you would like to contact us, please leave us the phone number and contact you.',
    joinusform: {
      name: 'Name',
      gender: 'Gender',
      gender1: 'Male',
      gender2: 'Female',
      databirth: 'Date of birth',
      phone: 'Mobile phone',
      email: 'E-mail',
      education: 'Education',
      addresstitle: 'Contact address',
      province: 'province',
      city: 'city',
      area: 'area',
      detailaddress: 'Please enter the detailed address',
      jobsearch: 'Education background',
      lastjob: 'Employment experience',
      submitbtn: 'Submit'
    },
    joinemail: "Please fill in the form and send your resume as an attachment to the company's recruitment email: hr@messenanjing.cn",
    exhform: {
      companyname: 'Company',
      address1: 'Country/area',
      address2: 'Address',
      name: 'Name',
      gender1: 'Male',
      gender2: 'Female',
      jobtitle: 'Job title',
      tel: 'tel',
      mobilephone: 'Mobile phone',
      email: 'E-mail',
      interstedex: 'The exhibition you are interested in',
      pinfang: 'Required Stand Space Sqm(fill in)',
      countrytext: "Country/City"
    },
    jonbtn: 'Job Description',
    applybtn: 'Apply Now',
    tableth: {
      th1: 'Name',
      th2: 'Date',
      th3: 'Venue',
      th4: 'Official Promotion',
      th5: 'For Visitor',
      th6: 'For Exhibitor'
    },
    timename: 'Time',
    tjsuccess: 'The submission was successful. Please wait patiently',
    keytitle: 'index'

  },
  navbar: {
    home: 'Home',
  },


}


// WEBPACK FOOTER //
// ./src/i18n/config/en.js